<template>
    <div class="content">
      <h4 class="title">
        Current Period
      </h4>

      <dl>
        <dt>completed transaction</dt>
        <dd>
          {{ metrics.companyJobCount }}
        </dd>

        <dt>Estimated Charges</dt>
        <dd>
          {{ estimatedCharges }}
        </dd>
      </dl>
    </div>
</template>

<script>
import MetricsApi from '@/api-interface/metrics'
import { format } from 'date-fns'
import numeral from 'numeral'
import { mapState } from 'vuex'
export default {
  name: 'CurrentPeriod',

  data() {
    return {
      metrics: {}
    }
  },

  async created() {
    const currentPeriod = format(new Date(), 'YYYYMM')
    const companyKey = this.currentCompanyInfo.companyKey
    const rawMetrics = await MetricsApi.list({ companyKey, period: currentPeriod })
    this.metrics = rawMetrics.find((metric) => metric.companyLevel)
  },

  computed: {
    ...mapState('company', ['currentCompanyInfo']),

    estimatedCharges() {
      let rate = 2
      if (this.currentCompanyInfo.companyBillingMethod === 'manual') {
        rate = 2.25
      }
      return numeral(this.metrics.companyJobCount * rate).format('$0,0.00')
    }
  }
}
</script>

<style scoped>
dt {
  text-transform: capitalize;
}

dt:after {
  content: ':';
}

dd {
  margin-bottom: 16px;
}
</style>
